import { useState } from 'react'
import { WrenchScrewdriverIcon } from '@heroicons/react/24/solid'
import { useRemoveSpamItemsMutation } from '../../api/client'
import ConfirmModal from '../ConfirmModal'

type Props = {
    contentIds: number[]
}

/**
 * Modal that allows the user to remove content from the spam model
 */
export default function RemoveSpamModal(props: Props) {
    const [open, setOpen] = useState(false)

    const [removeSpamItems, { loading }] = useRemoveSpamItemsMutation({
        onCompleted: (data) => {
            setOpen(false)
        }
    })

    return (
        <div>
            <button
                className="inline-flex mb-2 items-center rounded-md bg-arwen-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-arwen-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-arwen-600"
                onClick={() => setOpen(true)}
            >
                Remove all
            </button>
            <ConfirmModal
                open={open}
                onClose={() => setOpen(false)}
                onConfirm={() =>
                    removeSpamItems({
                        variables: {
                            contentIds: props.contentIds
                        }
                    })
                }
                title="Remove all from spam model"
                description={
                    <>
                        <p>This will remove all visible content from the spam model.</p>
                        <p>
                            If you only want to remove some of the items then use the Spam button on
                            the content card.
                        </p>
                    </>
                }
                confirmLabel="Remove all"
                loading={loading}
                icon={<WrenchScrewdriverIcon className="h-6 w-6" aria-hidden="true" />}
                iconClassName="bg-arwen-100 text-arwen-700"
            />
        </div>
    )
}
